import axios from 'axios';
import { applyAuthSessionHeaders, endAuthSession } from '@/domains/auth/services/auth-session.service';

// Crea una instancia de Axios
const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
});

api.interceptors.request.use(
  async (config) => {
    return applyAuthSessionHeaders(config);
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      await endAuthSession();
    }
    return Promise.reject(error);
  }
);

export default api;
